import "../../../App.css";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { alpha } from "@mui/material/styles";
import RoomIcon from "@mui/icons-material/Room";
import { format } from "date-fns";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import WbCloudyOutlinedIcon from "@mui/icons-material/WbCloudyOutlined";
import ThunderstormOutlinedIcon from "@mui/icons-material/ThunderstormOutlined";
import { ReactComponent as RainFallIcon } from "../../../assets/svgs/rainfall.svg";
import { ReactComponent as RainyIcon } from "../../../assets/svgs/rainy.svg";
import styled from "@emotion/styled";
import { useGetWeatherInfoQuery } from "../../../features/weather/WeatherSlice";
import { useTranslation } from "react-i18next";
import {
  CollapsableDiv,
  ContainerDiv,
  TimedNode,
} from "../shared/SharedComponents";

const WeatherMonitoringDiv = () => {
  const { t, i18n } = useTranslation();
  const getLocation = useLocation();
  const schedule = getLocation.state?.schedule;
  const { data, isLoading } = useGetWeatherInfoQuery(schedule.id, {
    pollingInterval: 60 * 1000,
  });

  return (
    <CollapsableDiv title={t("Weather Monitoring")}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <TimedNode
            calculateInterval={(time) => 60 - time.getSeconds()}
            render={(time) => (
              <>
                <div>
                  <div style={{ width: "max-content" }}>
                    {t("Date")}: {format(time, "dd/MM/yyyy")} (
                    {format(time, "eee")})
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      maxWidth: "300px",
                    }}
                  >
                    <RoomIcon />
                    {schedule.location}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "5px",
                      padding: "4px 8px",
                      backgroundColor: alpha("#4E7FDB", 0.3),
                      borderRadius: "4px",
                      fontFamily: "Squada One",
                      fontSize: "20px",
                    }}
                  >
                    {t("Work Type")}: {schedule.workType}
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: "auto",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    fontFamily: "Squada One",
                    backgroundColor: alpha("#4E7FDB", 0.3),
                    fontSize: "50px",
                    lineHeight: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {format(time, "hh:mma")}
                </div>
              </>
            )}
          />
        </div>
        <ContainerDiv
          style={{
            marginTop: "10px",
            fontFamily: "Squada One",
            backgroundColor: alpha("#4E7FDB", 0.3),
            padding: "10px",
            alignItems: "center",
          }}
        >
          {isLoading && (
            <div style={{ margin: "auto" }}>
              <CircularProgress></CircularProgress>
            </div>
          )}
          {!isLoading && (
            <>
              <ContentsDiv>
                {data?.weatherType == "sunny" && (
                  <LightModeOutlinedIcon sx={{ fontSize: "120px" }} />
                )}
                {data?.weatherType == "cloudy" && (
                  <WbCloudyOutlinedIcon sx={{ fontSize: "120px" }} />
                )}
                {data?.weatherType == "rainy" && (
                  <RainyIcon
                    stroke="white"
                    fill="white"
                    width={120}
                    height={120}
                  />
                )}
                {data?.weatherType == "thunderstorm" && (
                  <ThunderstormOutlinedIcon sx={{ fontSize: "120px" }} />
                )}
                <div
                  style={{
                    fontSize: "90px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                >
                  {data?.temperature} °C
                </div>
              </ContentsDiv>
              <WeatherIconDiv>
                <ContentsDiv>
                  <WaterDropOutlinedIcon />
                  <div>{data?.humidity}%</div>
                </ContentsDiv>
                {/* <ContentsDiv>
                                    <AirOutlinedIcon />
                                    <div>15km/h</div>
                                </ContentsDiv> */}
                <ContentsDiv>
                  <RainFallIcon />
                  <div>{data?.rainfall}mm</div>
                </ContentsDiv>
              </WeatherIconDiv>
            </>
          )}
        </ContainerDiv>
      </div>
    </CollapsableDiv>
  );
};

const ContentsDiv = styled.div`
  display: contents;
  @media (max-width: 1040px) {
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
`;

const WeatherIconDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  align-items: center;
  column-gap: 5px;
  font-size: 30px;
  margin-left: auto;
  @media (max-width: 1040px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 0px;
    justify-content: space-evenly;
  }
`;

export default WeatherMonitoringDiv;
